import facepaint from 'facepaint'

export const mq = facepaint(
  ['@media(min-width: 420px)', '@media(min-width: 980px)'],
  { literal: false },
)
